"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkKeys = exports.WARN_CIS_SYNC_LOGIN_UNDEFINED = void 0;
/* global window */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// Will not exist in Node.js envs, use with care
// @ts-ignore
var pulse_cis_sync_1 = require("@spt-tracking/pulse-cis-sync");
var debounce_1 = __importDefault(require("lodash/debounce"));
var merge_1 = __importDefault(require("lodash/merge"));
var logger = __importStar(require("loglevel"));
var mergeWith_1 = __importDefault(require("lodash/mergeWith"));
var uuid_1 = require("uuid");
var builders_1 = require("./builders");
var config_1 = __importDefault(require("./config"));
var defer_1 = __importDefault(require("./defer"));
var leaveTracking_1 = require("./leaveTracking");
var network_1 = __importDefault(require("./network"));
var version_json_1 = require("./version.json");
var warnOnce_1 = __importDefault(require("./warnOnce"));
// exported for testing
exports.WARN_CIS_SYNC_LOGIN_UNDEFINED = 'Cis sync initiated with no actor builder and no event available. If you do not use a login system, please indicate' +
    ' this using tracker.update({ actor: undefined }), otherwise do tracker.update({ actor: somePromise }) with a' +
    ' promise that resolves to the login state.';
var providerSdrn = builders_1.provider.generateProviderSDRN;
var evaluateAndFlatten = builders_1.utils.evaluateAndFlatten;
function getEventTrackingMethod(name) {
    // @ts-ignore
    return builders_1.events[name] || builders_1.events.trackerEvent;
}
exports.BookmarkKeys = {
    PAGE_VIEW: 'page-view',
};
var Tracker = /** @class */ (function () {
    /**
     * @param {string} providerId (*required*). Id of the site or app. Read the [integration
     * guide](https://docs.schibsted.io/pulse/integration_guide/step2/) to see where your providerId can be
     * registered and retrieved.
     * @param config
     * @param builders
     */
    function Tracker(providerId, config, builders) {
        var _this = this;
        var _a, _b;
        logger.setLevel((_a = config === null || config === void 0 ? void 0 : config.logLevel) !== null && _a !== void 0 ? _a : logger.levels.ERROR);
        if (!providerId || !(typeof providerId === "string")) {
            throw new Error("Required parameter `providerId` missing");
        }
        this.state = (0, merge_1.default)({}, config_1.default, {
            pageViewId: (0, uuid_1.v4)(),
            providerId: providerId,
        }, config);
        // Move to default config?
        this.builders = (0, merge_1.default)({}, builders, {
            provider: {
                id: providerId,
            },
            tracker: {
                version: "".concat(version_json_1.SDK_VERSION, "-").concat(version_json_1.GIT_COMMIT.slice(0, 5)),
            },
        });
        this.bookmark = new Map();
        // Replace with a linked list of Promises?
        this.eventQueue = [];
        this.retryEventQueue = [];
        // This is technically/strictly speaking not necessary to do before the
        // first event which requires an environmentId is sent. This will in most
        // cases be all events on client-instances and doing this immediately will
        // unblock the first event faster.
        // The reason for the timeout is to cover the case of
        // const tracker = new Tracker();
        // tracker.login('user@example.org');
        if (this.state.environment === "browser") {
            setTimeout(function () {
                _this.cisSync().then(function () { void (0); });
            }, 10);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if ((_b = window === null || window === void 0 ? void 0 : window.navigator) === null || _b === void 0 ? void 0 : _b.sendBeacon) {
                var originalUseBeacon_1 = this.state.useBeacon;
                window.addEventListener("pagehide", function () {
                    _this.state.useBeacon = true;
                    _this._sendImmediately().then(function () { void (0); });
                }, { capture: true });
                window.addEventListener("pageshow", function () {
                    _this.state.useBeacon = originalUseBeacon_1;
                });
            }
        }
    }
    /**
     * Sync our ids with cis given the userId from the event or builders.
     * @param data the event parameters (the data passed to `.track()`),
     * if called in a context where an event is being sent.
     *
     * @returns the parsed pulse cookie after syncing with cis.
     */
    Tracker.prototype.cisSync = function (data) {
        var _this = this;
        // At this point, neither this.builders nor data have been
        // evaluated through evaluateAndFlatten (this happens in `.track`),
        // so in the rare and weird case where `.actor` is a function or
        // a promise, or contains functions or promises, we will evaluate
        // these twice.
        // Note that this evaluation isn't 100% correct in that it ignores
        // things like eventDefaults, doesn't call the event builder associated
        // with the event type etc., but this shouldn't affect `.actor.{id,realm}`
        // in cases I can imagine (of course, my imagination is limited)
        //
        // we need an event, or at least this.builders.actor
        // to know the correct login/logout state for the user.
        // In some implementations (video plugin) the client will
        // populate the full event only on `.track` and not ever
        // call `.update(...)` with the login status.
        // Arguably this is incorrect, and `.update(...)` should be
        // called when login state changes, but we try to make
        // the API as fail-proof as possibly by handling the situation
        // here.
        //
        // However, we do cis syncs without access to an event, so
        // for this case, we need to just reuse the userId from the existing
        // _pulse2data cookie, or just not do the sync.
        //
        var dataObj = (data || {});
        var buildersObj = this.builders || {};
        if (!Object.prototype.hasOwnProperty.call(dataObj, "actor") &&
            !Object.prototype.hasOwnProperty.call(buildersObj, "actor")) {
            (0, warnOnce_1.default)("no-actor-builder-and-no-event-present", exports.WARN_CIS_SYNC_LOGIN_UNDEFINED);
            // TODO:  When all have converted, we can reject here, but before
            // that, we can't as all tracking etc will simply stop working
            // return Promise.reject(new ErrWARN_CIS_SYNC_LOGIN_UNDEFINED));
        }
        return evaluateAndFlatten(dataObj.actor || buildersObj.actor || {}).then(
        // @ts-ignore @TODO evaluateAndFlatten must resolve to a concrete type
        function (actor) {
            if (actor === void 0) { actor = { id: undefined, realm: undefined }; }
            var id = actor.id, realm = actor.realm; // {} because a Promise can resolve to undefined
            var _a = _this.state, nativeJwe = _a.nativeJwe, cisBaseUrl = _a.cisBaseUrl;
            if (_this.state.cisEnabled) {
                // @ts-ignore @TODO syncWithCis params must come from a concrete type
                return (0, pulse_cis_sync_1.syncWithCis)(id, nativeJwe, cisBaseUrl, realm, undefined, _this.state.xandrEnabled);
            }
            return Promise.resolve({ doTracking: true });
        });
    };
    /**
     * Add event to the tracker event queue
     *
     * The input can be objects, arrays, primitives or promises. The
     * order of calls to the method is not guaranteed to be sent in the same
     * sequence.
     *
     * ```
     * tracker.track('trackerEvent', {
     * actor: new Promise(resolve => setTimeout(() => resolve('person@example.org'), 2000))
     * });
     * tracker.track('trackerEvent', { type: 'Engagement '});
     *
     * ```
     *
     * The second call to `track` will be added to the event queue before the
     * first since all input to events are resolved before being added to the
     * internal queue. Setting the future value in the SDK state will block all
     * events and events will be added to the queue in order.
     *
     * ```
     * tracker.update({
     * actor: new Promise(resolve =>
     * setTimeout(() => resolve('person@example.org'), 2000)) })
     * tracker.track('trackerEvent', { type: 'View' });
     * tracker.track('trackerEvent', { type: 'Engagement' });
     * ```
     *
     * Both of these events will be blocked for two seconds and executed in order.
     *
     * @param {string} eventType. See [spt-tracking/pulse-event-builders]() for
     * available event types
     * @param {object} input. input input to the given event. The given input and the
     * persisted input in the tracker will be merged before passing it to the event
     * function.
     * @param {TrackOptions} options
     */
    Tracker.prototype.track = function (eventType, input, options) {
        var _this = this;
        var currentBuilders = __assign({}, this.builders);
        var _track = function (trackResponse) {
            return _this.evaluateEvent(eventType, input, currentBuilders).then(function (event) {
                var _a;
                // if we have an alternative handler defined, send events there
                // instead of pushing them onto the queue.
                if (_this.state.altEventHandler) {
                    var handler = _this.state.altEventHandler;
                    handler(JSON.stringify(event));
                    return Promise.resolve(trackResponse);
                }
                if (options === null || options === void 0 ? void 0 : options.bookmarkKey) {
                    _this.bookmark.set(options.bookmarkKey, event);
                }
                var eventOutput = Object.assign({}, event);
                if (options === null || options === void 0 ? void 0 : options.applyBookmarkKey) {
                    var bookmarkedPageViewEvent = (_a = _this.bookmark.get(options.applyBookmarkKey)) !== null && _a !== void 0 ? _a : {};
                    var _id = bookmarkedPageViewEvent["@id"], _type = bookmarkedPageViewEvent["@type"], _creationDate = bookmarkedPageViewEvent.creationDate, coreEvent = __rest(bookmarkedPageViewEvent, ['@id', '@type', "creationDate"]);
                    (0, merge_1.default)(eventOutput, coreEvent);
                }
                var queuedEvent = _this._push(eventOutput, options).then(function () { return void (0); });
                _this.send();
                return queuedEvent.then(function (result) { return result; });
            });
        };
        return this.cisSync(input).then(_track, _track);
    };
    /**
     * Evaluate all input given to the sdk/this method and pass it through the
     * appropriate event formatter.
     */
    Tracker.prototype.evaluateEvent = function (eventType, input, builders) {
        var _this = this;
        if (builders === void 0) { builders = this.builders; }
        var eventBuilder = getEventTrackingMethod(eventType);
        // @ts-ignore
        return this.evaluateEventInputs(eventType, input, builders).then(function (evaluatedInput) {
            // @ts-ignore
            return evaluateAndFlatten(eventBuilder(evaluatedInput, _this.state));
        });
    };
    Tracker.prototype.evaluateEventInputs = function (eventType, data, builders) {
        var _this = this;
        if (builders === void 0) { builders = this.builders; }
        var eventDefaults = getEventTrackingMethod(eventType).defaults;
        return Promise.all([
            evaluateAndFlatten(builders),
            evaluateAndFlatten(data),
        ]).then(function (builders) {
            var eventInput = builders.reduce(function (acc, p) { return (0, merge_1.default)(acc, p); }, {});
            return (0, merge_1.default)({}, eventDefaults(), eventInput, _this.evaluateConsents());
        });
    };
    /**
     * Enriches the event with consent data saved in state.
     */
    Tracker.prototype.evaluateConsents = function () {
        var consents = this.state.consents;
        return __assign({}, (consents && { consents: consents }));
    };
    /**
     * Adds the user's consents (opt-ins) to data processing for specific purposes, e.g. personalization.
     * These consent purposes must only be used if you want to
     * enrich Pulse events with the consent choices made by the current user.
     *
     * *WARNING:* It is critically important that
     * a consent is only added if the user has actually given that consent (opted in).
     * Only an explicit yes from the user means yes for these consents. Declined consent choices (opt-outs) must not be
     * added.
     *
     * Adding a consent purpose to the SDK saves it to the SDK state, and this consent state will be sent with every
     * outgoing event after going through the consents builder in \[@spt-tracking/pulse-event-builders].
     *
     * @param {ConsentedToPurposeInput} purposes (*required*). Consent purposes to be added to every outgoing event.
     * A consent purpose consists of a *category* and an *id*. Category is a textual representation of a consent purpose.
     * Possible values are CMP_ANALYTICS, CMP_MARKETING, CMP_ADVERTISING and CMP_PERSONALIZATION. The id is the
     * unique identifier of the consent purpose from the CMP.
     */
    Tracker.prototype.addConsentPurposes = function (purposes) {
        for (var category in purposes) {
            var consentCategory = category;
            this.addSingleConsentPurpose(consentCategory, purposes[consentCategory]);
        }
    };
    /**
     * Adds a single user consent (opt-in) to data processing for a specific purpose, e.g. personalization.
     * See also {@link addConsentPurposes}
     * @param {ConsentCategory} category (*required*). Purpose category to be attached to the events. Allowed values are
     * CMP_ANALYTICS, CMP_MARKETING, CMP_ADVERTISING and CMP_PERSONALIZATION
     * @param {string} id (*required*). Purpose ID if the allowed category.
     */
    Tracker.prototype.addSingleConsentPurpose = function (category, id) {
        var _a;
        var _b;
        if ((_b = this.state.consents) === null || _b === void 0 ? void 0 : _b.purposes) {
            this.state.consents.purposes[category] = id;
        }
        else {
            this.state.consents = {
                purposes: (_a = {},
                    _a[category] = id,
                    _a)
            };
        }
    };
    /**
     * Removes consent purposes from the SDK. This means that the SDK will consider that the user has declined these
     * consent purposes and will communicate this downstream.
     * @param {string[]} categories (*required*). Categories of the consent purposes the user has opted out of.
     */
    Tracker.prototype.removeConsentPurposes = function (categories) {
        for (var _i = 0, categories_1 = categories; _i < categories_1.length; _i++) {
            var category = categories_1[_i];
            this.removeSingleConsentPurpose(category);
        }
    };
    /**
     * Removes a single consent purpose from the SDK. This means that the SDK will consider that the user has declined
     * this consent purpose and will communicate this downstream.
     * @param {string} category (*required*). Category of the consent purposes the user has opted out of.
     */
    Tracker.prototype.removeSingleConsentPurpose = function (category) {
        var _a;
        (_a = this.state.consents) === null || _a === void 0 ? true : delete _a.purposes[category];
    };
    /**
     * Clears consent purposes. This must only be used if the user has opted out of all consent purposes.
     */
    Tracker.prototype.clearConsentPurposes = function () {
        this.replaceConsentPurposes({});
    };
    /**
     * Overrides consent purposes in the SDK. This sets the consent purposes in the SDK state to the given object. This
     * consent state will be sent with every outgoing event after going through the consents builder in
     * [@spt-tracking/pulse-event-builders].
     * @param {ConsentedToPurposeInput} purposes (*required*). Consent purposes to be added to every outgoing event.
     */
    Tracker.prototype.replaceConsentPurposes = function (purposes) {
        this.state.consents = {
            purposes: purposes
        };
    };
    /**
     * Return a new Tracker with the current state
     */
    Tracker.prototype.clone = function () {
        return new Tracker(this.state.providerId, __assign({}, this.state), __assign({}, this.builders));
    };
    /**
     * Update the persisted state that is passed to all events
     *
     * Calling
     * ```
     * tracker.update({ actor: 'person@example.org' });
     * tracker.trackPageView();
     * tracker.trackPageView();
     * ```
     *
     * is equivalent of doing
     *
     * ```
     * tracker.trackPageView({ actor: 'person@example.org' });
     * tracker.trackPageView({ actor: 'person@example.org' });
     * ```
     *
     * @param {EventInput} builder data passed to event functions
     *
     * @param {boolean} mergeBuilder the given data will be merged deeply with the
     * existing state. False will result in the previous state being overwritten
     */
    Tracker.prototype.update = function (builder, mergeBuilder) {
        if (mergeBuilder === void 0) { mergeBuilder = false; }
        function conflictResolver(objValue, srcValue) {
            if (objValue instanceof Promise || srcValue instanceof Promise) {
                return Promise.all([objValue, srcValue]).then(function (_a) {
                    var obj = _a[0], src = _a[1];
                    return (0, mergeWith_1.default)({}, obj, src, conflictResolver);
                });
            }
            return undefined;
        }
        if (mergeBuilder) {
            this.builders = (0, mergeWith_1.default)({}, this.builders, builder, conflictResolver);
        }
        else {
            this.builders = Object.assign({}, this.builders, builder);
        }
    };
    /**
     * Get the actor id (userId) from the current browser. A promise is returned
     * because a call may be made to complete the login process.
     *
     * *Note*: This method will return a Promise that is always rejected on node
     environments.
     */
    Tracker.prototype.getUserId = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this._userIsLoggedIn()];
                    case 1:
                        if (_b.sent()) {
                            return [2 /*return*/, Promise.resolve((_a = this.builders.actor) === null || _a === void 0 ? void 0 : _a.id)];
                        }
                        else {
                            return [2 /*return*/, Promise.resolve(undefined)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get the advertisement id (adId) from the current browser. A promise is returned
     * because a CIS call is done to generate a new adId if no cookie is
     * found.
     *
     * *Note*: This method will return a Promise that is always rejected on node
     environments.
     */
    Tracker.prototype.getAdId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cisSync({ actor: this.getActor() }).then(function (_a) {
                        var adId = _a.adId;
                        return adId;
                    })];
            });
        });
    };
    Tracker.prototype.getActor = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._userIsLoggedIn()];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/, this.builders.actor];
                        }
                        else {
                            return [2 /*return*/, { id: undefined }];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get the environment id from the current browser. A promise is returned
     * because a CIS call is done to generate a new environmentId if no cookie is
     * found.
     *
     * *Note*: This method will return a Promise that is always rejected on node
     environments.
     */
    Tracker.prototype.getEnvironmentId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cisSync({ actor: this.getActor() }).then(function (_a) {
                        var environmentId = _a.environmentId;
                        return environmentId;
                    })];
            });
        });
    };
    /**
     * Returns the PPID1 value for Xandr integration.
     * This is the "logged in identifier".
     */
    Tracker.prototype.getXandrPPID1 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._userIsLoggedIn()];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/, this.cisSync({ actor: this.getActor() })
                                    // adId is based on userId here
                                    .then(function (_a) {
                                    var adId = _a.adId;
                                    return adId ? _this._normalizeToXandrExtendedId(adId) : undefined;
                                })];
                        }
                        else {
                            return [2 /*return*/, Promise.resolve(undefined)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns the PPID2 value for Xandr integration.
     * This is the "not logged in identifier".
     */
    Tracker.prototype.getXandrPPID2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._userIsLoggedIn()];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/, this.getEnvironmentId()
                                    .then(function (it) { return _this._hashMessage(it, 'Xandr-PPID2'); })];
                        }
                        else {
                            // adId is based on deviceId (aaid, idfv, envId) here
                            return [2 /*return*/, this.cisSync({ actor: this.getActor() })
                                    .then(function (_a) {
                                    var adId = _a.adId;
                                    return adId ? _this._normalizeToXandrExtendedId(adId) : undefined;
                                })];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns the UUID currently used as the page view (will be muted by
     * `newPageView` and `trackPageView`).
     */
    Tracker.prototype.getPageViewId = function () {
        return this.state.pageViewId;
    };
    /**
     * Generate a new page view id. Will be attached to all events until a new
     * id is generated.
     */
    Tracker.prototype.newPageView = function () {
        this.state.pageViewId = (0, uuid_1.v4)();
    };
    /**
     * @private functions
     */
    Tracker.prototype._userIsLoggedIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            var buildersObj, actorPresent;
            return __generator(this, function (_a) {
                buildersObj = this.builders || {};
                actorPresent = Object.prototype.hasOwnProperty.call(buildersObj, 'actor');
                if (actorPresent) {
                    return [2 /*return*/, evaluateAndFlatten(buildersObj.actor).then(function (actor) {
                            if (actor === void 0) { actor = { id: undefined }; }
                            var hasActorValue = !!actor.id;
                            return Promise.resolve(hasActorValue);
                        })];
                }
                return [2 /*return*/, Promise.resolve(false)];
            });
        });
    };
    Tracker.prototype._hashMessage = function (message, salt) {
        return __awaiter(this, void 0, void 0, function () {
            var msgUint8;
            var _this = this;
            return __generator(this, function (_a) {
                msgUint8 = new TextEncoder().encode(message + salt);
                return [2 /*return*/, this._getSha256Digest(msgUint8).then(function (it) { return _this._toHexDigest(it); })];
            });
        });
    };
    /*
    For interoperability with other systems, use a standardized format
     */
    Tracker.prototype._toHexDigest = function (hashBuffer) {
        // convert buffer to byte array
        var hashArray = Array.from(new Uint8Array(hashBuffer));
        // convert bytes to hex string
        return hashArray.map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
    };
    Tracker.prototype._getSha256Digest = function (data) {
        return crypto.subtle.digest('SHA-256', data);
    };
    Tracker.prototype._normalizeToXandrExtendedId = function (rawIdentifier) {
        return rawIdentifier.replace(/[^a-zA-Z0-9-]/g, '-');
    };
    Tracker.prototype._getCollectorPath = function (providerId) {
        var _a = this.state, collectorBaseUrl = _a.collectorBaseUrl, collectorPath = _a.collectorPath, environment = _a.environment;
        if (environment === 'node') {
            return "".concat(collectorBaseUrl, "/").concat(collectorPath);
        }
        var _provider = providerId || this.state.providerId;
        if ((typeof _provider === 'string') && _provider.indexOf('sdrn') === 0) {
            return "".concat(collectorBaseUrl, "/").concat(collectorPath, "/").concat(_provider);
        }
        return "".concat(collectorBaseUrl, "/").concat(collectorPath, "/").concat(providerSdrn(_provider));
    };
    /**
     * Send all events that are in the internal event queue.
     *
     * The returned Promise will resolve with the array of events that was
     * successfully transmitted. These events will have been removed from the event
     * queue. If the promise rejects, it means that the event queue could not be
     * sent and the promise rejection will contain the events that failed (will be
     * the entire queue initial call). Events that are unsuccessfully sent will
     * remain in the event queue.
     *
     * @private
     *
     */
    Tracker.prototype._sendImmediately = function () {
        var _this = this;
        if (this.eventQueue.length + this.retryEventQueue.length > 0) {
            var promisesToBeSent_1 = this.eventQueue.splice(0);
            var eventsToBeSent_1 = promisesToBeSent_1.map(function (p) { return p.inputValue; });
            var eventsToRetry_1 = this.retryEventQueue;
            this.eventQueue = [];
            this.retryEventQueue = [];
            // @ts-ignore @TODO cisSync must resolve to a concrete type
            return this.cisSync().then(function (_a) {
                var _b = _a === void 0 ? {} : _a, doTracking = _b.doTracking;
                if (!doTracking) {
                    return Promise.resolve([]);
                }
                return Promise.all(eventsToBeSent_1)
                    .then(function (evaluatedEvents) {
                    var url = _this._getCollectorPath(_this.state.providerId);
                    return (0, network_1.default)(url, __spreadArray(__spreadArray([], evaluatedEvents, true), eventsToRetry_1, true), _this.state)
                        .then(function (response) {
                        if (response.status >= 400) {
                            // We retry an event once, but discard already retried events
                            _this.retryEventQueue = _this.retryEventQueue.concat(evaluatedEvents);
                            promisesToBeSent_1.map(function (promise) { return promise.reject(response); });
                            return Promise.reject(evaluatedEvents);
                        }
                        promisesToBeSent_1.map(function (promise) { return promise.resolve(response); });
                        return Promise.resolve(evaluatedEvents);
                    }, function (response) {
                        // We retry an event once, but discard already retried events
                        _this.retryEventQueue = _this.retryEventQueue.concat(evaluatedEvents);
                        promisesToBeSent_1.map(function (promise) { return promise.reject(response); });
                        return Promise.reject(evaluatedEvents);
                    });
                });
            });
        }
        return Promise.resolve([]);
    };
    Tracker.prototype._push = function (event, options) {
        if (options === void 0) { options = {}; }
        var deferredEvent = (0, defer_1.default)(event);
        this.eventQueue.push(deferredEvent);
        if (options.resolveOnQueued) {
            deferredEvent.resolve(event);
        }
        return deferredEvent.promise;
    };
    Tracker.prototype.getBookmarkedEvent = function (bookmarkKey) {
        return this.bookmark.get(bookmarkKey);
    };
    /**
     * Send the current event queue to the back end event receiver. This event is
     * debounced, see {SDKConfigInput} to override the default timing.
     *
     * This method is called by `track()` so it is not necessary to call after
     * adding events to the queue.
     */
    Tracker.prototype.send = function () {
        var _this = this;
        if (this.state.useBeacon) {
            return this._sendImmediately().catch(function (err) { return err; });
        }
        if (!this.debouncedSend) {
            // @ts-ignore
            this.debouncedSend = (0, debounce_1.default)(function () {
                return _this._sendImmediately().catch(function (err) { return err; });
            }, this.state.eventDebounce);
        }
        return this.debouncedSend();
    };
    /**
     * A convenience method which first updates the current pageViewId in the
     * tracker state and then sends a `tracker-event` with `@type: View` and the
     * merged result of the given data and the data saved in the tracker.
     *
     * Equivalent to
     *
     * ```
     * tracker.newPageView();
     * tracker.track('trackerEvent', { type: 'View', ...data });
     * ```
     *
     */
    Tracker.prototype.trackPageView = function (data, options) {
        if (data === void 0) { data = {}; }
        if (options === void 0) { options = {}; }
        this.newPageView();
        return this.track('trackerEvent', __assign({ type: 'View' }, data), __assign(__assign({}, options), { bookmarkKey: exports.BookmarkKeys.PAGE_VIEW }));
    };
    /**
     * Start sending events when users leave a page.
     * This will register handlers on the browser events 'pagehide', 'popstate' and 'visibilitychange'
     * and will send a Leave event when these are triggered. The leave event will be a copy of the last sent view-event
     * + engagement values. The fields in the default
     * event can be found here: https://pages.github.schibsted.io/mpt-data/pulse-standard/#leave-article.
     * The Leave event can be expanded further by passing an event-builder as the third param, but this is not recommended.
     *
     * Example usage:
     *
     * ```
     *  const pageElement = document.querySelector('#application') || document.body;
     *  const articleElement = document.getElementById('article-element');
     *  tracker.addPageLeaveTracking(articleElement, pageElement);
     * ```
     *
     * Passing '{ objectResizable: true }' as the 4th param makes the SDK re-calculate the object height whenever it changes,
     * which is usefull for when the page or object changes size after loading, by ex
     * ```
     *  ...
     *  tracker.addPageLeaveTracking(articleElement, pageElement, undefined, {
     *    objectResizable: true,
     *  });
     * ```
     *
     * Keep in mind that the Beacon API is used to send events to page leave, and in order to guarantee as good as
     * possible that these events are sent, the event creator parameter should be synchronous.
     *
     * For the same reasons, we advise that the event creator parameter returns an event that does not contain any promises.
     *
     * @param {Element} objectElement The DOM element that is used to calculate various view-related fields in the default event.
     * @param {Element} pageElement The DOM element that represents the page that the user is currently on.
     * @param {LeaveEventBuilder} eventBuilder Function that returns an event to send when user leaves the page.
     * @param {LeaveEventOptions} options
     * @returns {(leaveEvent: LeaveEvent) => void} A function to update the event to send on page leave.
     */
    Tracker.prototype.addPageLeaveTracking = function (objectElement, pageElement, eventBuilder, options) {
        if (options === void 0) { options = {}; }
        (0, leaveTracking_1.addPageLeaveTracking)(this, objectElement, pageElement, eventBuilder, options);
        return leaveTracking_1.updatePageLeaveEvent;
    };
    /**
     * Stop sending events when users leave a page.
     * Removes all event handlers, meaning that to event will be sent if the user leaves the page.
     */
    Tracker.prototype.removePageLeaveTracking = function () {
        (0, leaveTracking_1.removePageLeaveTracking)(this);
    };
    /**
     * Update leave tracking.
     * Updates the DOM element used to calculate the default fields in the Leave event.
     * @param {Element} objectElement The DOM element that is used to calculate various view-related fields in the default event.
     * @param {Element} pageElement The DOM element that represents the page that the user is currently on.
     * @param {boolean} resetProperties A flag that decided whether the properties of the default Leave event should
     * be reset when the tracking is updated. Defaults to false.
     */
    Tracker.prototype.updatePageLeaveTracking = function (objectElement, pageElement, resetProperties) {
        if (resetProperties === void 0) { resetProperties = false; }
        (0, leaveTracking_1.updatePageLeaveTracking)(objectElement, pageElement, resetProperties);
    };
    /**
     * Manually trigger a viewed content recalculation
     * @param {Element} objectElement The DOM element that is used to calculate various view-related fields in the
     * default event.
     * @param {Element} pageElement The DOM element that represents the page that the user is currently on.
     */
    Tracker.prototype.resetPageLeaveViewedContent = function (objectElement, pageElement) {
        (0, leaveTracking_1.resetViewedContent)();
        (0, leaveTracking_1.updateViewedContent)(objectElement, pageElement);
    };
    /**
     * Manually trigger a Leave event
     * Useful if for example the consuming website is an SPA and the normal browser events are not triggered.
     * is generated internally in the SDK.
     * @param {LeaveEvent=} eventInput
     * @param {eventName=} eventName The optional name of the browser event to simulate.
     */
    Tracker.prototype.trackPageLeave = function (eventInput, eventName) {
        (0, leaveTracking_1.trackPageLeave)(this, eventInput, eventName);
    };
    /**
     * Manually trigger a Leave event only if Page Leave tracking is active in the SDK
     * This method works similarly to
     * ```
     * trackPageLeave(event: LeaveEvent, eventName?: string)
     * ```
     * with the added guarantee that a second Leave event will not be triggered if one already has been sent.
     * is generated internally in the SDK.
     * @param {LeaveEvent=} eventInput
     * @param {eventName=} eventName The optional name of the browser event to simulate.
     */
    Tracker.prototype.trackActivePageLeave = function (eventInput, eventName) {
        (0, leaveTracking_1.trackActivePageLeave)(this, eventInput, eventName);
    };
    return Tracker;
}());
exports.default = Tracker;
